import type { ReactElement, RefObject } from "react";
import { pxToRem } from "@/theme/spacing";
import type { ParsedKanban } from "./parse-mermaid-kanban";
import { KanbanColumn } from "./KanbanColumn";
import type { SetColumnRefInput } from "./useKanbanBoardScroll";
import { ROOT_GAP } from "./kanban-view-constants";
interface KanbanBoardProps {
    parsed: ParsedKanban;
    scrollContainerRef: RefObject<HTMLDivElement | null>;
    activeHoveredCardKey: string | null;
    setColumnRef: (input: SetColumnRefInput) => void;
    onHoverCard: (cardKey: string) => void;
    clearHoveredCard: () => void;
}
export function KanbanBoard({ parsed, scrollContainerRef, activeHoveredCardKey, setColumnRef, onHoverCard, clearHoveredCard, }: KanbanBoardProps): ReactElement {
    return (
      <div data-el="Cmarkdownkanban/Board/Viewport" ref={scrollContainerRef} onMouseLeave={clearHoveredCard} onPointerLeave={clearHoveredCard} style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "stretch",
            gap: ROOT_GAP,
            overflowX: "auto",
            overflowY: "hidden",
            paddingBottom: pxToRem(2),
            scrollSnapType: "x mandatory",
        }}>
        {parsed.columns.map((column, columnIndex) => (<KanbanColumn key={column.id} column={column} columnIndex={columnIndex} activeHoveredCardKey={activeHoveredCardKey} setColumnRef={setColumnRef} onHoverCard={onHoverCard} clearHoveredCard={clearHoveredCard}/>))}
      </div>
    );
}
